import { cn } from "@/lib/utils";
import { Icon, type IconName } from "./icon";

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  icon?: IconName;
}

export interface SegmentedProps<T extends string> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  size?: "sm" | "md";
}

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  size = "md",
}: SegmentedProps<T>) {
  return (
    <div className={cn("segmented", size === "sm" && "seg-sm")}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={cn("seg-item", value === o.value && "active")}
          onClick={() => onChange(o.value)}
        >
          {o.icon && <Icon name={o.icon} size={15} />}
          {o.label}
        </button>
      ))}
    </div>
  );
}
